export default function getActivityEndpoints(build) {
  return {
    getActivityCarousel: build.query({
      query: id => `/Activities/${id}/carousel-photos`,
    }),
  };
}
